const Bloom = ({ cx, cy, r = 16, petals = 5 }) => (
  <g>
    {Array.from({ length: petals }).map((_, i) => (
      <path
        key={i}
        transform={`rotate(${(360 / petals) * i} ${cx} ${cy})`}
        d={`M${cx} ${cy - r} C ${cx + r * 0.45} ${cy - r * 0.6}, ${cx + r * 0.45} ${cy - r * 0.2}, ${cx} ${cy} C ${cx - r * 0.45} ${cy - r * 0.2}, ${cx - r * 0.45} ${cy - r * 0.6}, ${cx} ${cy - r} Z`}
      />
    ))}
    <circle cx={cx} cy={cy} r={r * 0.22} />
  </g>
);

export const BotanicalSpray = ({ className = "", flip = false }) => (
  <svg
    viewBox="0 0 220 220"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.1"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    style={flip ? { transform: "scaleX(-1)" } : undefined}
    aria-hidden="true"
  >
    <path d="M14 208 C 52 152, 80 118, 134 84" />
    <path d="M134 84 C 152 72, 170 66, 190 62" />
    <path d="M60 150 C 44 144, 36 130, 39 116 C 53 123, 61 135, 60 150 Z" />
    <path d="M88 122 C 78 108, 77 94, 84 84 C 94 95, 95 110, 88 122 Z" />
    <path d="M110 102 C 114 86, 125 77, 138 75 C 133 90, 123 100, 110 102 Z" />
    <path d="M42 176 C 30 172, 23 162, 25 151 C 36 156, 42 165, 42 176 Z" />
    <Bloom cx={190} cy={56} r={17} />
    <Bloom cx={150} cy={100} r={10} petals={5} />
  </svg>
);

export const BotanicalDivider = ({ className = "" }) => (
  <svg
    viewBox="0 0 320 28"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M0 14 H120" opacity="0.6" />
    <path d="M200 14 H320" opacity="0.6" />
    <Bloom cx={160} cy={14} r={9} petals={5} />
    <path d="M138 14 C 130 10, 126 6, 126 2 C 133 5, 137 9, 138 14 Z" />
    <path d="M182 14 C 190 10, 194 6, 194 2 C 187 5, 183 9, 182 14 Z" />
  </svg>
);
